// extracted by mini-css-extract-plugin
export default {"wrapper":"Steps_wrapper__Emz0e","title":"Steps_title__2vJpR","stepWrapper":"Steps_stepWrapper__E4k0m"};